var $ac0041dae2f30090$exports = {};
$ac0041dae2f30090$exports = {
  "help": `Yard\u{131}m`,
  "info": `Bilgiler`
};
export { $ac0041dae2f30090$exports as default };